var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClipboardCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fit: "",
    height: "100%",
    width: "100%",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12 8v12h-12v-12h12zm-1.5 1.5h-9v9h9v-9zm6.5-4.5h-11v-1.5h-1.5v3.5h-1.5v-5h3v-2h11v2h3v16h-7v-1.5h5.5v-13h-1.5v1.5zm-1.5-3.5h-8v2h8v-2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboardCopy);
export default __webpack_public_path__ + "static/media/clipboard-copy.f4cc762f18e26b32746267eb5bdfa6e5.svg";
export { ForwardRef as ReactComponent };